export default {
  batchList: {
    path: {
      listPathName: '结算批次列表',
      addPathName: '结算批次创建',
      editPathName: '结算批次编辑',
    },
    search: {
      settleCreateDateStart: '创建日期起',
      settleCreateDateEnd: '创建日期止',
    },
    column: {
      id: '序号',
      settleNo: '结算批次编号',
      settleDesc: '结算批次描述',
      settleType: '结算类型',
      shippingName: '装运名称',
      deliveryQuantity: '发货数量',
      supplierNo: '供应链主体',
      productNo: '商品编码',
      productDesc: '商品描述',
      settleDepartmentName: '部门',
      settleCreatePersonName: '创建人',
      settleCreateDate: '创建日期',
      settleStatus: '结算批次状态',
      mark: '备注',
      orderNo: '业务订单',
    },
    message: {
      noSelected: '您还未选择任何数据!',
      noExport: '当前没有数据可以导出！',
      onlyOneSelectData: '请选择一条数据进行操作',
    },
  },
  batchAdd: {
    placeholder: {
      auto: '自动生成',
    },
    message: {
      supplierNoMsg: '请填写供应链主体',
      settleCompanyNoMsg: '请填写公司代码',
      deliveryQuantityMsg: '请填写发货数量',
      orderNoMsg: '请填写业务订单号',
      noDepartment: '缺少对应部门，请维护',
      noProductMsg: '缺少商品，请维护',
      putInStorageMsg: '业务入库单明细归集数量总数不能超过发货数量！',
      ladingBillMsg: '提单明细归集数量总数不能超过发货数量！',
      cannotCreateAllot: '请选择相同的仓库！',
      noSettleBatchNo: '请先保存该条结算批次！',
      deliveryQuantity: '当前发货数量已改变，请先导入关联信息！',
      supplierNo: '当前供应链主体已改变，请先导入关联信息！',
      settleCompanyNo: '当前公司已改变，请先导入关联信息！',
      settleDepartmentNo: '当前部门已改变，请先导入关联信息！',
    },
    button: {
      add: '新增',
      delete: '删除',
      correlationBtn: '导入关联信息',
      createAllot: '生成库存调拨单',
      exportDetailBtn: '导出关联信息',
    },
    collapseTitle: {
      baseTitle: '基本信息',
      correlationTitle: '关联信息',
    },
    tabsName: {
      procurement: '采购合同明细',
      putInStorage: '业务入库单明细',
      payment: '付款明细',
      salesContract: '销售合同明细',
      ladingBill: '提单明细',
      collection: '收款明细',
      cost: '费用明细',
      fundsInterests: '资金利息',
    },
    baseForm: {
      settleNo: '结算批次编号',
      settleDesc: '结算批次描述',
      settleType: '结算类型',
      shippingName: '装运名称',
      deliveryQuantity: '发货数量',
      unitCode: '单位',
      supplierName: '供应链主体',
      productDesc: '商品描述',
      benchmarkRate: '基准税率',
      settleCompanyNo: '公司',
      settleDepartmentNo: '部门',
      settleCreatePersonNo: '创建人',
      settleCreateDate: '创建日期',
      mark: '备注',
      orderNo: '业务订单号',
      interestType: '利率类型',
      interestUnit: '利率计价单位',
      stopInterestDate: '停止计息日期',
      dateStart: '开始时间',
      dateEnd: '结束时间',
      businessDepartmentName: '业务部门',
    },
    procurement: {
      add: '新增',
      remove: '删除',
      save: '保存',
      sortNo: '序号',
      contractCreateDate: '合同日期',
      supplierName: '供应商',
      contractNo: '采购管理号',
      externalContractNo: '外部采购合同号',
      contractStatusName: '合同状态',
      contractDetailNo: '合同行项目',
      productNo: '商品编码',
      productDesc: '商品描述',
      unitName: '单位',
      productQuantity: '合同数量',
      businessContractUnitPrice: '合同单价',
      businessContractTotalAmount: '合同金额',
      collectionQuantity: '归集数量',
      unCollectionQuantity: '未归集数量',
      payAmount: '付款金额',
      deliveredQuantity: '交付数量',
      invoiceQuantity: '收票数量',
      invoiceAmount: '收票金额',
    },
    putInStorage: {
      businessDialogTitle: '业务入库单明细',
      sortNo: '序号',
      businessInboundNo: '业务入库单号',
      businessInboundBatchNo: '业务入库批次号',
      businessInboundDetailNo: '业务入库单行项目',
      contractNo: '采购合同号',
      contractDetailNo: '采购合同行项目号',
      productNo: '商品编码',
      productDesc: '商品描述',
      productUnitName: '单位',
      inboundQuantity: '业务入库数量',
      collectionQuantity: '归集数量',
      unCollectionQuantity: '未归集数量',
      storageCode: '仓库',
      allotNo: '库存调拨单',
      businessVariablePrice: '业务入库单单价',
      collectionAmount: '归集金额',
      storageName: '仓库',
    },
    payment: {
      sortNo: '序号',
      purchaseOrderNo: '采购管理号',
      paymentApplyNumber: '付款申请单号',
      paymentNum: '付款单号',
      externalContractNo: '外部采购合同号',
      paymentDate: '付款日期',
      paymentAmount: '付款金额',
      receiveCompanyName: '收款单位',
      paymentType: '付款类别',
      inboundQuantity: '入库吨数',
      unitPrice: '单价',
      totalAmount: '总货款',
      marginAmount: '保证金',
      marginAmountPercent: '保证金比例(%)',
      mark: '备注',
    },
    // 销售明细
    salesContract: {
      contractCompanyName: '公司',
      contractBusinessDepartmentName: '事业部门',
      contractCreateDate: '合同日期',
      customerName: '客户',
      contractNo: '销售管理号',
      externalContractNo: '外部销售合同号',
      contractStatusName: '合同状态',
      contractDetailNo: '合同行项目',
      productNo: '商品编码',
      productDesc: '商品描述',
      productQuantity: '合同数量',
      businessContractUnitPrice: '合同单价',
      businessContractTotalAmount: '合同金额',
      collectionQuantity: '归集数量',
      unCollectionQuantity: '未归集数量',
      receiptConditionName: '付款条件',
      pickedQuantity: '实提数',
      collectableAmount: '应收款金额',
      cutPayment: '扣款',
      collectedAmount: '已收款金额',
      unCollectAmount: '未收款金额',
      invoiceType: '发票类型',
      goldenTaxDate: '开票日期',
      canIssuedInventoryQuantity: '可开单库存数量',
      restPickingQuantity: '客户剩余可提数量',
      lastestReceiveMoneyDay: '应收款日期',
      // collectableAmount: '应收款金额',
      // collectedAmount: '已收款金额',
      // unCollectAmount: '未收款金额'
    },
    ladingBill: {
      ladingBillDialogTitle: '提单明细',
      indexNo: '序号',
      externalContractNo: '外部合同号',
      contractNo: '合同号',
      customerName: '客户名称',
      ladingNo: '提单编号',
      contractDetailNo: '合同商品行项目号',
      ladingDetailNo: '提单明细行项目号',
      pickingBusinessInboundBatchNo: '拣配批次',
      ladingCreateDate: '提单日期',
      productNo: '商品编码 ',
      productDesc: '商品描述',
      businessInboundBatchNo: '入库批次号',
      collectionQuantity: '归集数量 ',
      unCollectionQuantity: '未归集数量',
      ladingUnit: '单位',
      ladingQuantity: '提单数量',
      businessPickingQuantity: '拣配数量',
      businessContractUnitPrice: '单价',
      businessLadingAmount: '金额',
      businessChangingUnitPrice: '提单单价',
      collectionAmount: '归集金额',
    },
    // 收款明细
    collection: {
      sortNo: '序号',
      registerNo: '收款登记号',
      contractNo: '销售管理号',
      externalContractNo: '外部销售合同号',
      contractDetailNo: '行项目号',
      registerDate: '收款日期',
      originReceiveMoneyAmount: '收款金额',
      payerName: '付款单位',
      receivedType: '收款类别',
      mark: '备注',
    },
    // 费用明细
    cost: {
      costDialogTitle: '费用明细',
      sortNo: '序号',
      documentCode: '单据编号',
      payableInvoiceCreateDate: '发票日期',
      invoiceUnitName: '开票单位',
      invoiceCode: '发票号',
      totalAmount: '开票金额',
      taxRate: '税率',
      taxAmount: '税额',
      amountWithoutTax: '不含税金额',
      expenseType: '费用类型',
      expenseTypeName: '明细',
      belongPeriod: '做账日期',
      isPaid: '是否已付款',
      supplierName: '合作方',
      mark: '备注',
      payableInvoiceCompanyCode: '公司',
      payableInvoiceDepartmentCode: '部门',
      contractNoList: '采购合同',
      invoiceUnitNo: '开票单位',
    },
    // 资金利息
    fundsInterests: {
      fundsInterestsDialogTitle: '资金计息利率配置表',
      sumName: '合计',
      sortNo: '序号',
      date: '日期',
      payAmount: '付款金额',
      payTon: '付款折合吨数',
      collectAmount: '收款金额',
      collectTon: '收款折合吨数',
      contractUnitPrice: '合同均价',
      gap: '差额',
      fundInterest: '资金利息',
      orderNo: '框架协议编号',
      interestType: '利率类型',
      interestUnit: '利率计价单位',
      occupationPeriod: '资金占用周期',
      interestEffectiveStartDays: '利率期限起始天数',
      interestEffectiveEndDays: '利率期限到期天数',
      interestRate: '利率',
      remark: '备注',
    },
  },
};
